import { setupForDark } from '@theme';
import classNames from 'classnames';
import { ReactNode } from 'react';
import Button from './Button';

export default function StickyActionButton({
  children,
  onClick,
  type = 'tertiary'
}: {
  children: ReactNode;
  onClick: () => void;
  type?: 'tertiary' | 'primary';
}) {
  return (
    <div
      className={classNames(
        'sticky bottom-0',
        'flex justify-center items-center',
        'w-full',
        'pt-sm pb-xxxl px-md',
        'border-t-[1px]',
        setupForDark('bg-primary', 'border-t-primary')
      )}
    >
      <Button onClick={onClick} type={type} size='large' extraClassName='P3M' fullWidth>
        {children}
      </Button>
    </div>
  );
}
